import { useTranslation } from 'react-i18next'
import { BaseLogo, ImageLogo, LogoEditStatus, LogoType } from '../../../core/models/entities/BaseLogo'
import { ApprovalDisplay, ApprovalListDisplay } from '../Approval/ApprovalDisplay'

export function LogoStatusElement({ logo }: { logo: BaseLogo }) {
  const { t } = useTranslation()
  const imageLogo = logo as ImageLogo
  // Foreign-org rows (admin/act-as lists) can lack the approval group the
  // non-draft branches assert with `!` — degrade to the Unknown status text
  // instead of letting ApprovalDisplay throw the list into RouteErrorView.
  if (imageLogo.status !== LogoEditStatus.Unknown && imageLogo.status !== LogoEditStatus.Draft && !imageLogo.approval) {
    return <p className="mb-1 font-semibold text-xs text-gray-600">{t("compLogoDesign.statusUnknown")}</p>
  }
  switch (imageLogo.status) {
    case LogoEditStatus.Unknown:
      return <p className="mb-1 font-semibold text-xs text-gray-600">{t("compLogoDesign.statusUnknown")}</p>
    case LogoEditStatus.Draft:
      return <p className="mb-1 font-semibold text-xs text-orange-400">{t("compLogoDesign.statusDraft")}</p>
    case LogoEditStatus.Rejected:
      return <ApprovalDisplay approval={imageLogo.approval!} />
    case LogoEditStatus.Validating:
      return <ApprovalDisplay approval={imageLogo.approval!} />
    case LogoEditStatus.Done:
      return <ApprovalListDisplay approval={logo.approval!} />
    // return logo.logoType === LogoType.ImageLogo ?
    //   <ApprovalListDisplay approval={imageLogo.approval!} /> :
    //   <p className="mb-1 font-semibold text-xs text-status-success">APPROVED</p>
  }
}

